import axios from 'axios'

export default {
  globalactionmemberList (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/globalactionmember', { params: opts })
        .then(({ data }) => {
          context.commit('GLOBAL_ACTION_MEMBER_LIST', data)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // ===========================Socket Updates=====================
  globalactionmemberUpdated (context, opts) {
    const id = opts && opts.id ? opts.id : opts
    const populated = opts && opts.populate ? opts.populate : []
    const inList = context.state.list.find((i) => i.id === id)
    if (inList) {
      axios
        .get(`/api/globalactionmember/${id}`, { params: populated })
        .then(({ data }) => {
          if (data.id) {
            data.socketUpdate = true
            context.commit('GLOBAL_ACTION_MEMBER_LIST_UPDATE', data)
          }
        }).catch(() => {})
    }
  },
  globalactionmemberDestroyed (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inList = context.state.list.find((i) => i.id === id)
    if (id === context.state.current.id) {
      context.commit('GLOBAL_ACTION_MEMBER_CURRENT', null)
    }
    if (inList) {
      context.commit('GLOBAL_ACTION_MEMBER_LIST_REMOVE', id)
    }
  }
}
